/* eslint-disable react/jsx-no-bind */

'use client';

import { useEffect, useState } from 'react';
import { useFormState } from 'react-dom';
import Input from '@referralexchange/rea-ui-react/src/atoms/Input';
import Textarea from '@referralexchange/rea-ui-react/src/atoms/Textarea';
import Checkbox from '@referralexchange/rea-ui-react/src/atoms/Checkbox';
import Button from '@referralexchange/rea-ui-react/src/atoms/Button';
import { submitCcpaRequest } from './actions';
import styles from './page.module.scss';

const initialState = {
  alert: '',
  message: '',
  values: {},
};

export default function PrivacyChoicesForm() {
  const [state, formAction] = useFormState(submitCcpaRequest, initialState);
  const [values, setValues] = useState({
    name: '',
    email: '',
    phone: '',
    comments: '',
    know: false,
    delete: false,
    correct: false,
    optOut: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (state.alert) {
      setLoading(false);
    }
  }, [state]);

  function handleChange(e) {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  }

  function handleCheckboxChange(e) {
    const { name, checked } = e.target;
    setValues((prev) => ({ ...prev, [name]: checked }));
  }

  function handleSubmit() {
    setLoading(true);
  }

  if (state.alert === 'success') {
    return (
      <div className={styles.wrapper}>
        <div className={styles.card}>
          <h1 className={styles.title}>Request Submitted</h1>
          <div className={styles.divider} />
          <p className={styles['success-text']}>
            Thank you! Your privacy request has been submitted successfully. We will
            process your request and respond within the timeframe required by
            applicable law (typically within 45 days).
          </p>
          <p className={styles['contact-text']}>
            If you would like to speak to our team about your request, please email us at
            {' '}
            <a href="mailto:support@realestateagents.com">support@realestateagents.com</a>
            {' '}
            or call us directly at
            {' '}
            <a href="tel:+18885862349">(888) 586-2349</a>
            .
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <h1 className={styles.title}>Consumer Privacy Act Requests</h1>
        <div className={styles.divider} />

        <form className={styles.form} action={formAction} onSubmit={handleSubmit}>
          <Input
            label="Name"
            name="name"
            value={values.name}
            onChange={handleChange}
            required
          />

          <Input
            label="Email"
            name="email"
            type="email"
            value={values.email}
            onChange={handleChange}
            required
          />

          <Input
            label="Phone Number"
            name="phone"
            type="tel"
            value={values.phone}
            onChange={handleChange}
          />

          <div className={styles['checkbox-group']}>
            <p className={styles['checkbox-group-label']}>What would you like to do?</p>

            <Checkbox
              name="know"
              checked={values.know}
              onChange={handleCheckboxChange}
            >
              I&apos;d like to know what personal information you have about me
            </Checkbox>

            <Checkbox
              name="delete"
              checked={values.delete}
              onChange={handleCheckboxChange}
            >
              I&apos;d like you to delete my personal information
            </Checkbox>

            <Checkbox
              name="correct"
              checked={values.correct}
              onChange={handleCheckboxChange}
            >
              I&apos;d like to correct inaccurate personal information about me
            </Checkbox>

            {values.correct && (
              <Textarea
                label="Please describe the inaccurate information you'd like corrected"
                name="comments"
                value={values.comments}
                onChange={handleChange}
                rows={4}
              />
            )}

            <Checkbox
              name="optOut"
              checked={values.optOut}
              onChange={handleCheckboxChange}
            >
              I&apos;d like to opt out of the sale or sharing of my personal information,
              including targeted advertising
            </Checkbox>
          </div>

          <p className={styles.disclaimer}>
            These rights are available to U.S. residents under applicable privacy laws.
          </p>

          {state.alert === 'error' && state.message && (
            <p className={styles.error}>{state.message}</p>
          )}

          <div className={styles['button-wrapper']}>
            <Button loading={loading} disabled={loading} type="submit">
              Request
            </Button>
          </div>
        </form>

        <p className={styles['contact-text']}>
          If you would like to speak to our team about your request, please email us at
          {' '}
          <a href="mailto:support@realestateagents.com">support@realestateagents.com</a>
          {' '}
          or call us directly at
          {' '}
          <a href="tel:+18885862349">(888) 586-2349</a>
          .
        </p>
      </div>
    </div>
  );
}
